module.exports = __webpack_public_path__ + "h5/img/cygn6.b00b5cbd.png";